<template>
  <div>
    <section ref="giftCon" class="section-gift">
      <div v-for="(item, index) in showList" :key="index" class="gift-con">
        <div class="gift-bg"></div>
        <img class="avatar" :src="item.avatar" alt="壹心理直播-打赏">
        <div class="content">
          <p class="nickname">{{ decodeURI(item.nickname) }}</p>
          <p class="gift-name">送出<span>{{ item.giftName }}</span></p>
        </div>
        <div class="gift-img-con">
          <img class="gift-img" :src="item.giftImg" alt="壹心理直播-打赏">
        </div>
        <div class="gift-num">x<span>{{ item.giftNum }}</span></div>
      </div>
    </section>

    <!--打赏大动画-->
    <section class="gifs-sec">
      <img v-show="gifs[8]" class="gifs-default" src="../../assets/images/gifts/call.gif" alt="壹心理打赏">
      <img v-show="gifs[7]" class="gifs-default" src="../../assets/images/gifts/love.gif" alt="壹心理打赏">
      <img v-show="gifs[6]" class="gifs-superman" src="../../assets/images/gifts/superman.gif" alt="壹心理打赏">
      <img v-show="gifs[5]" class="gifs-default" src="../../assets/images/gifts/redPacket.gif" alt="壹心理打赏">
    </section>
  </div>
</template>

<script>
  export default {
    name: "giftAnimate",
    props: {
      newGift: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        gifs: {
          5: false,
          6: false,
          7: false,
          8: false
        },
        isShow: false, // 当前是否有礼物在显示中
        showList: [], // 显示礼物队列
        giftStore: [] // 礼物队列
      }
    },
    watch: {
      newGift(val) {
        /*新礼物推入队列*/
        this.giftStore.push(val)
        this.handleShowGift()
      },
      isShow(val) {
        if (!val && this.giftStore.length > 0) {
          this.handleShowGift()
        }
      }
    },
    methods: {
      handleShowGift() {
        if (this.isShow) return
        // 如果当前没有正在显示的礼物，则取队列第一个出来显示
        const temp = this.giftStore.splice(0, 1)
        this.isShow = true
        this.showList.push(...temp)
        if (this.hasGif(temp[0].giftId)) {
          this.gifs[temp[0].giftId] = true
        }
        const showGiftTimeout = setTimeout(() => {
          this.isShow = false
          if (this.hasGif(temp[0].giftId)) {
            this.gifs[temp[0].giftId] = false
          }
          showGiftTimeout && clearTimeout(showGiftTimeout)
        }, 2000)
      },
      /*判断是否有gif动画*/
      hasGif(id) {
        const arr = Object.keys(this.gifs)
        return arr.includes(id.toString())
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  .section-gift {
    margin-bottom: 30px;

    .gift-con {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      padding: 12px;
      height: 100px;
      box-sizing: border-box;

      transform: translateX(-500px);
      opacity: 1;
      animation: giftAnimate 2s forwards;

      .avatar {
        margin-left: 12px;
        z-index: 10;
        width: 76px;
        height: 76px;
        border-radius: 50%;
      }

      .content {
        z-index: 10;
        margin-left: 10px;
        display: flex;
        flex-direction: column;

        .nickname {
          width: 180px;

          font-family: PingFangSC-Medium;
          font-size: 22px;
          color: #FFED5A;

          @include overLine(1)
        }

        .gift-name {
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #FFFFFF;

          span {
            padding-left: 6px;
            font-family: PingFangSC-Medium;
            font-size: 28px;
            color: #FFFFFF;
          }
        }
      }

      .gift-img-con {
        width: 120px;
        height: 92px;

        .gift-img {
          max-width: 120px;
          max-height: 92px;
        }
      }

      .gift-num {
        margin-left: 30px;

        font-family: SFProDisplay-Black;
        font-size: 36px;
        color: #FFFFFF;
        font-weight: bold;

        span {
          font-family: SFProDisplay-Black;
          font-size: 60px;
        }
      }
    }

    @keyframes giftAnimate {
      0% {
        transform: translateX(-300px);
      }
      30% {
        transform: translateX(0);
      }
      51% {
        opacity: 1;
      }
      100% {
        transform: translateX(0);
        opacity: 0;
      }
    }

    .gift-bg {
      position: absolute;
      width: 360px;
      height: 100px;

      background-image: linear-gradient(266deg, rgba(118,142,255,0.00) 0%, #768EFF 70%, #FF917D 100%);
      border-radius: 50px;
    }
  }

  .gifs-sec {
    .gifs-default {
      position: fixed;
      bottom: 150px;
      left: 50%;
      transform: translateX(-50%);
      width: 600px;
      z-index: 99;
    }

    .gifs-superman {
      position: fixed;
      bottom: 100px;
      left: -300px;
      width: 600px;
      z-index: 99;

      animation: supermanAnimate 2s forwards;
    }

    @keyframes supermanAnimate {
      0% {
        bottom: 100px;
        left: -300px;
      }
      20% {
        bottom: 200px;
        left: 100px;
      }
      80% {
        bottom: 200px;
        left: 100px;
      }
      100% {
        bottom: 400px;
        left: 800px;
      }
    }
  }
</style>
